// formate price (10000 => 10 000)
const formatePrice = num => {
  return num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1 ")
}

export default formatePrice



// WEBPACK FOOTER //
// ./app/utils/formatePrice.js